'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce = require('hs-lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _notifyBySound = require('../sound-notifications/notifyBySound');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOTIFICATION_DEBOUNCE_MS = 2000;

var VisitorNotificationMiddleware = function VisitorNotificationMiddleware() {
  var playNotifications = (0, _debounce2.default)(function () {
    (0, _notifyBySound.notifyBySound)(false);
  }, NOTIFICATION_DEBOUNCE_MS, { leading: true, trailing: false, maxWait: NOTIFICATION_DEBOUNCE_MS });

  function isRecipientMessage(message) {
    var from = (0, _commonMessageFormatGetters.getSenderType)(message);
    return from === _senderTypes.AGENT || from === _senderTypes.BOT;
  }

  return function (next) {
    return function (action) {
      switch (action.type) {
        case ActionTypes.RECEIVED_INCOMING_MESSAGE:
          {
            var _action$payload = action.payload,
                message = _action$payload.message,
                shouldNotify = _action$payload.shouldNotify;

            if (shouldNotify && isRecipientMessage(message) && (0, _messageTypeComparators.isChatMessage)(message)) {
              playNotifications();
            }
            break;
          }

        case ActionTypes.OPEN_CONVERSATION_FOR_NEW_CHANNEL:
          {
            var shouldNotifyBySound = action.payload.shouldNotifyBySound;

            if (shouldNotifyBySound) {
              playNotifications();
            }
            break;
          }

        default:
          break;
      }

      return next(action);
    };
  };
};

exports.default = VisitorNotificationMiddleware;
module.exports = exports['default'];